import React from "react";
import { Navigate, RouteObject } from "react-router-dom";
import Dashboard from "../pages/auth/dashboard";
import Transaction from "../pages/auth/transactions/transactions";
import SingleTransaction from "../pages/auth/transactions/single-transaction";
import UserAccounts from "../pages/auth/user-accounts/user-accounts";
import SingleUserAccount from "../pages/auth/user-accounts/show";
import { Auth, AuthToken } from "../lib/auth/auth-store";
import Settings from "../pages/auth/settings";
import UserMetric from "../pages/auth/metric/user-metric";
import ListNotifications from "../pages/auth/notification/push-notification";
import Savings from "../pages/auth/savings";
import SupportTicketDashboard from "../pages/auth/support-ticket";
import SingleSupportTicket from "../pages/auth/support-ticket/single-ticket";
import BusinessMerchant from "../pages/auth/business-merchant";
import SingleBusinessMerchant from "../pages/auth/business-merchant/show";
import BusinessDocumentation from "../pages/auth/business-merchant/documentation/Index";
import BusinessTransction from "../pages/auth/business-merchant/transaction";
import SingleBusinessTransaction from "../pages/auth/business-merchant/transaction/show";
import AccountDashboard from "../pages/auth/account-dashboard";
import Loan from "../pages/auth/loan";
import SingleLoan from "../pages/auth/loan/show";
import ServiceStatus from "../pages/auth/service-status";

type RouteType = {
  path: string;
  element: React.ReactNode;
};

const routes: RouteType[] = [
  { path: "/", element: <Dashboard /> },
  { path: "/accounts", element: <AccountDashboard /> },
  { path: "/transactions", element: <Transaction /> },
  { path: "/transactions/:transactionId", element: <SingleTransaction /> },
  { path: "/savings", element: <Savings /> },
  { path: "/user-accounts", element: <UserAccounts /> },
  { path: "/user-accounts/:userId", element: <SingleUserAccount /> },
  { path: "/business-merchants", element: <BusinessMerchant /> },
  { path: "/business-transactions", element: <BusinessTransction /> },
  {
    path: "/business-transactions/:reference",
    element: <SingleBusinessTransaction />,
  },
  { path: "/business-merchants/:code", element: <SingleBusinessMerchant /> },
  {
    path: "/business-merchants/:code/documentation",
    element: <BusinessDocumentation />,
  },
  { path: "/settings", element: <Settings /> },
  { path: "/service-status", element: <ServiceStatus /> },
  { path: "/analytics", element: <UserMetric /> },
  { path: "/notifications", element: <ListNotifications /> },
  { path: "/loans", element: <Loan /> },
  { path: "/loans/:reference", element: <SingleLoan /> },

  { path: "/support-ticket", element: <SupportTicketDashboard /> },
  { path: "/support-ticket/:code", element: <SingleSupportTicket /> },
];

// Check if authenticated
const middleware = () => {
  const isAuthenticated = Boolean(!!AuthToken());

  return routes.map((route) => ({
    path: route.path,
    element: isAuthenticated ? (
      handleRouting(route.path, route.element)
    ) : (
      <Navigate to="/login" />
    ),
  }));
};

const handleRouting = (path: string, element: React.ReactNode) => {
  const { role } = Auth();

  if (role === "super_admin") {
    return element;
  }

  if (path.startsWith("/support-ticket")) {
    return element;
  }

  return <Navigate to="/support-ticket" />;
};

const AuthRoutes: RouteObject[] = middleware();

export default AuthRoutes;
